import { apiService } from './index';
import { TOKEN } from '../contexts/authContext';
import { IExportCaseCreation } from '../shared/types/caseCreation';

export const asyncPostCaseCreation = (formdata: any) => {
    return apiService.post('/api/case-creation', formdata, undefined, {
        accept: '*/*',
        Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN),
    });
};

export const asyncGetCasesCreations = async (
    page?: number,
    pageSize?: number,
    startDate?: any,
    endDate?: any,
    document?: string,
    status?: string
) => {
    return await apiService.get('/api/case-creation', {
        limit: pageSize || 20,
        page: page || 0,
        startDate: startDate || '',
        endDate: endDate || '',
        document: document || '',
        status: status || '',
    });
};

export const asyncPostExportCaseCreation = async (
    formExport: IExportCaseCreation
) => {
    return await apiService.post('/api/case-creation/export', formExport);
};
